module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(true) ? _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item._id,
      staticClass: "white-background mail-item clickable hoverable",
      on: {
        "click": function($event) {
          return _vm.toggleExpansion(item)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "truncate",
      staticStyle: {
        "flex-grow": "1"
      }
    }, [_c('strong', [_vm._v(_vm._s(item.email.subject))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex-basis": "100px",
        "margin-left": "10px",
        "text-align": "right",
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(_vm._f("fromNow")(item.createdAt)))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "width": "100%"
      }
    }, _vm._l((item.email.to), function(recipient) {
      return _c('div', {
        key: recipient.to,
        staticClass: "email-address truncate",
        attrs: {
          "title": recipient.email
        }
      }, [_vm._v("\n                " + _vm._s(recipient.email) + " \n            ")])
    }), 0), _vm._v(" "), (_vm.showTo) ? _c('div', {
      staticClass: "email-heading"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "300"
      }
    }, [_vm._v(_vm._s(_vm.textBody(item.email.body, item.expanded)))])])
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fabfa66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TransactionMail.vue
// module id = 2521
// module chunks = 1